import { render, staticRenderFns } from "./UserComponent.vue?vue&type=template&id=650d53ec&"
import script from "./UserComponent.vue?vue&type=script&lang=ts&"
export * from "./UserComponent.vue?vue&type=script&lang=ts&"
import style0 from "./UserComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports